import cx from "classnames";

import { Dots } from "components/icons/generated";
import Box from "ds/components/Box";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import useMainNavigationMobileMenuItems from "components/MainNavigation/hooks/useMobileMenuItems";

import MainNavigationMobileMenuItem from "./MenuItem";
import styles from "./styles.module.css";

const MainNavigationMobile = () => {
  const mobileMenuItems = useMainNavigationMobileMenuItems();
  const setMobileFullScreen = useMainNavigationStore((state) => state.setMobileFullScreen);

  return (
    <div className={cx(styles.mainNavigationWrapperMobile)}>
      <Box padding="medium large">
        <Box gap="medium" justify="between" align="center" fullWidth className={styles.menu}>
          {mobileMenuItems.map(({ id, icon, to, routeRule, title }) => (
            <MainNavigationMobileMenuItem
              key={id}
              icon={icon}
              to={to}
              rule={routeRule}
              ariaLabel={title}
              className={styles.menuItem}
            >
              {title}
            </MainNavigationMobileMenuItem>
          ))}
          <MainNavigationMobileMenuItem
            id="menu-more"
            icon={Dots}
            ariaLabel="Menu open"
            className={styles.menuItem}
            onClick={() => setMobileFullScreen(true)}
          >
            Menu
          </MainNavigationMobileMenuItem>
        </Box>
      </Box>
    </div>
  );
};

export default MainNavigationMobile;
